import { render, staticRenderFns } from "./xmxjList.vue?vue&type=template&id=2462671a&scoped=true&"
import script from "./xmxjList.vue?vue&type=script&lang=js&"
export * from "./xmxjList.vue?vue&type=script&lang=js&"
import style0 from "./xmxjList.vue?vue&type=style&index=0&id=2462671a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2462671a",
  null
  
)

export default component.exports